export default function LocationController(
    $scope,
    $routeParams,
    activities, // resolved
    locations, //resolved
    ActivityFactory,
    LocationFactory,
    houseService,
    DummyApi,
    Error,
    $location,
    ENV,
    $timeout,
    Scroll,
    siteService
) {
    /***
     * VARS
     */
    let location = null;

    /**
     * $scope VARS
     */
    $scope.items = null;

    /**
     * grap activity url slug
     */
    const slug = {
        location: $routeParams.location
            ? decodeURI($routeParams.location)
            : null,
    };

    if (slug.location) {
        location = LocationFactory.findLocationBySlug(slug.location, locations);

        if (location instanceof Error) {
            $location.path("/locations");
            return false;
        }

        $scope.location = location;
    }

    /*******************************************************
     * Scenenarios
     */

    /**
     * Single location
     */
    if (DummyApi.isEnabled()) {
        $scope.items = DummyApi.getLocation();
    } else {
        houseService.overviewFilter
            .getItemsCombo(1, 0, location.ID)
            .then(function (locations) {
                $scope.items = locations;

                $timeout(() => {
                    Scroll.to("title-focus", siteService.headerHeight + 15);
                });
            });
    }

    $scope.selectHouse = function (activity) {
        updateSearchLocation(location);

        updateSearchActivity(
            ActivityFactory.findActivityBySlug(activity.Name, activities) // find the correct activity model
        );

        // OPEN CALENDER DROPDOWN IN SEARCHBAR
        var oSearchInput = 2; // oSearchCalender has index 2 in the search-bar input array

        $scope.$broadcast("redirect-on-date-select");

        $scope.$broadcast(
            "activate-searchbar-dropdown-broadcast",
            oSearchInput
        );
    };

    var updateSearchActivity = function (activity) {
        houseService.searchFilter.houseCategory = activity;
        houseService.searchFilter.syncSearchBar(activity);
    };

    var updateSearchLocation = function (location) {
        houseService.searchFilter.houseType = location;
        houseService.searchFilter.syncSearchBar(location);
    };
}
